// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2W_wV","bigColWidth":"Table_bigColWidth__3tduC","biggerColWidth":"Table_biggerColWidth__3r7GG","row":"Table_row__2qAzw","col":"Table_col__3IOUW"};